import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Form, FormControl, Validators} from '@angular/forms';
import {WorkrequestPfiViewmodel} from '../workrequest-pfi-viewmodel';
import {LoginService} from '../../../shared/services/login.service';
import {FeeService} from '../../../shared/services/fee.service';
import {SERVICE_PROVIDER} from '../../../shared/services/fee.service';
import {WorkrequestPfiDetails} from '../workrequest-pfi-details';
import {AddressService} from '../../../shared/services/address.service';

@Component({
  selector: 'app-workrequest-pfi',
  templateUrl: './workrequest-pfi.component.html',
  styleUrls: ['./workrequest-pfi.component.css']
})
export class WorkrequestpfiComponent implements OnInit {
  @Input()
  isReadOnly = false;
  @Input()
  workRequestViewModel: WorkrequestPfiViewmodel;
  @Output()
  onViewModelChange: EventEmitter<WorkrequestPfiViewmodel>;
  @Output()
  onFeeCodesReceived: EventEmitter<void>;

  //nextWorkingDayRequiredControl: FormControl;
  within5BusinessDaysRequiredControl: FormControl;
  singleSupplyPointRequiredControl: FormControl;
  alternateSupplyPointRequiredControl: FormControl;
  percentPressureRequiredControl: FormControl;
  descriptionOfWorkControl: FormControl;
  descriptionOfWorkControlMaxLength = 5000;
  pricingZone: string = SERVICE_PROVIDER.CWW;

  constructor(private loginService: LoginService, private feeService: FeeService, private addressService: AddressService) {
    if (!this.workRequestViewModel) {
      this.workRequestViewModel = new WorkrequestPfiViewmodel();
    }
    if (!this.workRequestViewModel.workrequestDetails) {
      this.workRequestViewModel.workrequestDetails = new WorkrequestPfiDetails();
    }

    this.onFeeCodesReceived = new EventEmitter();
    //this.nextWorkingDayRequiredControl = new FormControl();
    this.within5BusinessDaysRequiredControl = new FormControl();
    this.singleSupplyPointRequiredControl = new FormControl();
    this.alternateSupplyPointRequiredControl = new FormControl();
    this.percentPressureRequiredControl = new FormControl();
    this.descriptionOfWorkControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.descriptionOfWorkControlMaxLength)
    ])]);

    // fetch pricing zone (CWW / WW)
    this.addressService.getPricingZone().subscribe(_pricingzone => {
      this.pricingZone = _pricingzone.toUpperCase() === SERVICE_PROVIDER.WW ? SERVICE_PROVIDER.WW : SERVICE_PROVIDER.CWW;
      console.log('PrizeZone:', this.pricingZone);
    }, err => {
      this.pricingZone = SERVICE_PROVIDER.CWW;
    });
  }

  ngOnInit() {
    this.loadFees();
  }

  resetSupplyPoints(): void {
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).alternateSupplyPointrequired = false;
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).singleSupplyPointrequired = false;
  }

  loadFees(): void {
    this.feeService.retrieveFees('PressureAndFlow', this.loginService.getToken(), ok => {
        if (ok) {
          //this.workRequestViewModel.nextWorkDayFeeAmount = this.feeService.getNextWorkingDayFeeAmount(this.pricingZone);
          this.workRequestViewModel.within5BusinessDaysAmount = this.feeService.getWithin5BusinessDayFeeAmount(this.pricingZone);
          this.onFeeCodesReceived.emit();
          this.calculateTotalAmount();
        } else {
          console.log('no fees found');
        }
      },
      err => {
        // Log errors if any
        console.log(err);
      });
  }

  public calculateTotalAmount(): void {
    this.workRequestViewModel.workrequestDetails.totalOrderAmount = (this.within5BusinessDaysrequired ?
      this.within5BusinessDaysAmount : 0);
      //+ (this.nextWorkingDayrequired ? this.nextWorkingDayAmount : 0);
  }

  get within5BusinessDaysAmount(): number {
    return this.workRequestViewModel.within5BusinessDaysAmount;
  }

  // get nextWorkingDayAmount(): number {
  //   return this.workRequestViewModel.nextWorkDayFeeAmount;
  // }

  // get nextWorkingDayrequired(): boolean {
  //   return (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).nextWorkingDayrequired;
  // }

  // set nextWorkingDayrequired(v: boolean) {
  //   (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).nextWorkingDayrequired = v;
  //   (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).within5BusinessDaysrequired = !v;
  //   this.calculateTotalAmount();
  // }

  get within5BusinessDaysrequired(): boolean {
    return (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).within5BusinessDaysrequired;
  }

  set within5BusinessDaysrequired(v: boolean) {
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).within5BusinessDaysrequired = v;
    //(<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).nextWorkingDayrequired = !v;
    this.calculateTotalAmount();
  }

  get singleSupplyPointrequired(): boolean {
    return (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).singleSupplyPointrequired;
  }

  set singleSupplyPointrequired(v: boolean) {
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).singleSupplyPointrequired = v;
    if (v) {
      (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).alternateSupplyPointrequired = false;
    }
  }

  get alternateSupplyPointrequired(): boolean {
    return (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).alternateSupplyPointrequired;
  }

  set alternateSupplyPointrequired(v: boolean) {
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).alternateSupplyPointrequired = v;
    if (v) {
      (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).singleSupplyPointrequired = false;
    }
  }

  get requiredWorkRequestPfiPercentPressure(): boolean {
    return (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).requiredWorkRequestPfiPercentPressure;
  }

  set requiredWorkRequestPfiPercentPressure(v: boolean) {
    if (!v) {
      this.descriptionOfWork = '';
    }
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).requiredWorkRequestPfiPercentPressure = v;
    if (v) {
      this.descriptionOfWorkControl.enable();
    } else {
      this.descriptionOfWorkControl.disable();
    }
  }

  get invalid(): boolean {
    if (!this.validateAll()) {
      return false;
    }
  }

  get errorMessage(): string {
    return this.workRequestViewModel.errorMessage;
  }

  set errorMessage(v: string) {
    this.workRequestViewModel.errorMessage = v;
  }

  get totalOrderAmount(): number {
    return (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).totalOrderAmount;
  };

  get descriptionOfWork(): string {
    return (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).descriptionOfWork;
  }

  set descriptionOfWork(v: string) {
    (<WorkrequestPfiDetails>this.workRequestViewModel.workrequestDetails).descriptionOfWork = v;
  }

  // public validateNextWorkingDayRequiredControlFee(): boolean {
  //   return this.nextWorkingDayrequired;
  // }

  public validateWithin5BusinessDaysRequiredControlFee(): boolean {
    return this.within5BusinessDaysrequired;
  }

  public validateSingleSupplyPointRequiredControlFee(): boolean {
    return this.singleSupplyPointrequired;
  }

  public validateAlternateSupplyPointRequiredControlFee(): boolean {
    return this.alternateSupplyPointrequired;
  }

  public validateAll(): boolean {
    this.workRequestViewModel.invalidSelectionError = '';

    // if (!this.validateNextWorkingDayRequiredControlFee() && !this.validateWithin5BusinessDaysRequiredControlFee()) {
    //   this.workRequestViewModel.invalidSelectionError = 'Please select valid work request.';
    //   return false;
    // }

    if (!this.validateSingleSupplyPointRequiredControlFee() && !this.validateAlternateSupplyPointRequiredControlFee()) {
      this.workRequestViewModel.invalidSelectionError = 'Please select valid supply point.';
      return false;
    }

    if (this.requiredWorkRequestPfiPercentPressure && this.descriptionOfWorkControl.invalid) {
      return false;
    }

    return true;
  }

  displayErrorMessage(): string {
    //this.nextWorkingDayRequiredControl.markAsTouched();
    this.within5BusinessDaysRequiredControl.markAsTouched();
    this.singleSupplyPointRequiredControl.markAsTouched();
    this.alternateSupplyPointRequiredControl.markAsTouched();

    this.errorMessage = null;

    let errorText = '';

    if (!this.validateAll()) {
      errorText += this.workRequestViewModel.invalidSelectionError + '<br>';
    }

    this.descriptionOfWorkControl.markAsTouched();
    if (this.requiredWorkRequestPfiPercentPressure && this.descriptionOfWorkControl.invalid) {
      if (this.descriptionOfWorkControl.hasError('maxlength')) {
        errorText += 'Additional Comments cannot exceed ' + this.descriptionOfWorkControlMaxLength + ' characters' + '<br>';
      }
      if (this.descriptionOfWorkControl.hasError('required')) {
        errorText += 'Please enter Additional Comments.' + '<br>';
      }
    }

    this.markValidationControlsAsUntouched();
    this.errorMessage = errorText.length > 0 ? errorText : null;
    return errorText;
  }

  markValidationControlsAsUntouched() {
    //this.nextWorkingDayRequiredControl.markAsUntouched();
    this.within5BusinessDaysRequiredControl.markAsUntouched();
    this.singleSupplyPointRequiredControl.markAsUntouched();
    this.alternateSupplyPointRequiredControl.markAsUntouched();
    this.descriptionOfWorkControl.markAsUntouched();
    this.loadFees();
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/pfi-form/workrequest-pfi/workrequest-pfi.component.ts